import { useTranslation } from '@cobliteam/i18n';

export enum RoutingSpreadsheetNoPermissionMessage {
  POC = 'poc_no_permission',
  AnalyticsAndReport = 'analytics_report_no_permission',
}

export const getRoutingSpreadsheetNoPermissionMessage = (messageType: RoutingSpreadsheetNoPermissionMessage) => {
  const { t } = useTranslation('routing');
  return t(`permissions.${messageType}`);
};
